(function () {
  'use strict';

  var ROTATIONS = [-22, 16, -38, 28, -14, 34];
  var GAP_FACTORS = [0.45, 1.2, 0.35, 1.45, 0.65, 1.05, 0.5, 1.35, 0.75, 1.15];
  var PAIR_FACTORS = [0.9, 1.35, 1.05, 1.55, 0.85, 1.25];

  function readPxVar(el, name, fallback) {
    if (!el) return fallback;
    var value = getComputedStyle(el).getPropertyValue(name).trim();
    if (!value) return fallback;
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function getCircleScope(layer) {
    var blockRoot = layer.closest('[data-ag-pb-circles-root]');
    if (blockRoot) return blockRoot;

    var sectionId = layer.getAttribute('data-ag-pb-section-id');
    if (sectionId) {
      var byId = document.getElementById('shopify-section-' + sectionId);
      if (byId) return byId;
    }

    return (
      layer.closest('.shopify-section--ag-page-blocks') ||
      layer.closest('.ag-page-blocks') ||
      layer.parentElement
    );
  }

  function getLayerState(layer) {
    if (!layer._agPbCirclesState) {
      layer._agPbCirclesState = {
        circleRatio: null,
        observer: null,
        rendering: false,
        bound: false,
        retryTimer: null
      };
    }
    return layer._agPbCirclesState;
  }

  // The circle is a decorative gradient shown ~370px wide on phones; don't ship the 1225px original there.
  function circleSrc(layer) {
    var url = layer.getAttribute('data-circle-url') || '';
    if (
      url &&
      url.indexOf('cdn.shopify.com') > -1 &&
      url.indexOf('width=') === -1 &&
      window.matchMedia('(max-width: 740px)').matches
    ) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=640';
    }
    return url;
  }

  function appendCircle(layer, side, top, rot, width, eager) {
    var img = document.createElement('img');
    img.className = 'ag-page-blocks__circle ag-page-blocks__circle--' + side;
    img.src = circleSrc(layer);
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.style.top = top + 'px';
    img.style.width = width + 'px';
    img.style.transformOrigin = 'center center';
    img.style.transform =
      (side === 'left' ? 'translateX(-50%) ' : 'translateX(50%) ') + 'rotate(' + rot + 'deg)';
    img.loading = eager ? 'eager' : 'lazy';
    img.decoding = 'async';
    layer.appendChild(img);
  }

  function measureZoneHeight(layer, scope) {
    var layerHeight = layer.clientHeight || layer.offsetHeight || 0;
    if (layerHeight > 0) return layerHeight;

    if (!scope) return 0;
    var scopeHeight = scope.clientHeight || scope.offsetHeight || 0;
    if (scopeHeight <= 0) return 0;

    var insetTop = readPxVar(scope, '--ag-page-blocks-circle-inset-top', 0);
    var insetBottom = readPxVar(scope, '--ag-page-blocks-circle-inset-bottom', 0);
    return Math.max(0, scopeHeight - insetTop - insetBottom);
  }

  function placeCircles(layer) {
    var state = getLayerState(layer);
    var scope = getCircleScope(layer);
    if (!state.circleRatio || !scope) return;

    var url = layer.getAttribute('data-circle-url');
    if (!url) return;

    var zoneHeight = measureZoneHeight(layer, scope);
    if (zoneHeight <= 0) {
      if (state.retryTimer) return;
      state.retryTimer = window.setTimeout(function () {
        state.retryTimer = null;
        placeCircles(layer);
      }, 100);
      return;
    }

    layer.innerHTML = '';

    var gap = readPxVar(scope, '--ag-page-blocks-circle-gap', 200);
    var pairGap = readPxVar(scope, '--ag-page-blocks-circle-pair-gap', 200);
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var isDesktop = window.matchMedia('(min-width: 741px)').matches;
    var maxWidth = isDesktop
      ? Math.min(1400, viewportWidth * 0.85)
      : Math.min(viewportWidth, viewportWidth * 0.9);
    var renderedHeight = maxWidth * state.circleRatio;
    var y = gap * 0.3;
    var index = 0;

    while (y + renderedHeight <= zoneHeight) {
      var side = index % 2 === 0 ? 'right' : 'left';
      var rot = ROTATIONS[index % ROTATIONS.length];
      appendCircle(layer, side, y, rot, maxWidth, index === 0);

      y += renderedHeight + gap * GAP_FACTORS[index % GAP_FACTORS.length];
      if (index % 2 === 1) {
        y += pairGap * PAIR_FACTORS[Math.floor(index / 2) % PAIR_FACTORS.length];
      }
      index += 1;
    }

    /*
      Short zones (collapsed accordions, short sections) are shorter than one
      full circle tile — loop places nothing. Force L/R glows; overflow clipped.
    */
    if (index < 2) {
      layer.innerHTML = '';
      var topRight = Math.max(0, zoneHeight * 0.2 - renderedHeight * 0.25);
      var topLeft = Math.max(0, zoneHeight * 0.55 - renderedHeight * 0.3);
      appendCircle(layer, 'right', topRight, ROTATIONS[0], maxWidth, true);
      appendCircle(layer, 'left', topLeft, ROTATIONS[1], maxWidth, false);
    }
  }

  function renderLayer(layer) {
    var state = getLayerState(layer);
    var url = layer.getAttribute('data-circle-url');
    if (!url) return;

    if (state.circleRatio) {
      placeCircles(layer);
      return;
    }

    if (state.rendering) return;
    state.rendering = true;

    var probe = new Image();
    probe.decoding = 'async';
    probe.src = circleSrc(layer);
    probe.onload = function () {
      state.rendering = false;
      if (!probe.naturalWidth || !probe.naturalHeight) return;
      state.circleRatio = probe.naturalHeight / probe.naturalWidth;
      placeCircles(layer);
    };
    probe.onerror = function () {
      state.rendering = false;
    };
  }

  function bindLayer(layer) {
    if (!layer || !layer.classList || !layer.classList.contains('js-ag-pb-circles')) return;

    var state = getLayerState(layer);
    var scope = getCircleScope(layer);
    if (!scope) return;

    renderLayer(layer);

    if (state.bound) return;
    state.bound = true;

    if (typeof ResizeObserver !== 'undefined') {
      state.observer = new ResizeObserver(function () {
        window.requestAnimationFrame(function () {
          renderLayer(layer);
        });
      });
      state.observer.observe(scope);
      state.observer.observe(layer);
    }
  }

  function layersIn(scope) {
    var list = [];
    if (!scope) return list;

    if (scope.classList && scope.classList.contains('js-ag-pb-circles')) {
      list.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('.js-ag-pb-circles'), function (el) {
        if (list.indexOf(el) === -1) list.push(el);
      });
    }

    return list;
  }

  function initCircleGradients(scope) {
    var root = scope && (scope.nodeType === 1 || scope.querySelectorAll) ? scope : document;
    layersIn(root).forEach(bindLayer);
  }

  function onResize() {
    document.querySelectorAll('.js-ag-pb-circles').forEach(function (layer) {
      renderLayer(layer);
    });
  }

  function boot() {
    initCircleGradients(document);
  }

  /* Singleton — safe when multiple AG Page Blocks sections each load this asset */
  if (window.__AG_PB_CIRCLES__) {
    window.__AG_PB_CIRCLES__.refresh(document);
    return;
  }

  window.__AG_PB_CIRCLES__ = {
    refresh: initCircleGradients,
    renderLayer: renderLayer
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function () {
    window.requestAnimationFrame(onResize);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCircleGradients(event.target || document);
  });

  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:block:select', function (event) {
    var root =
      event.target && event.target.closest
        ? event.target.closest('.shopify-section--ag-page-blocks, [data-ag-pb-circles-root]')
        : null;
    initCircleGradients(root || document);
  });
})();
